"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { addScrollEvent, removeScrollEvent } from "../components/VirtualizedTable/utils";
export function useSynchronizedScroll(element, otherElement) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== element || $[1] !== otherElement) {
    t0 = () => {
      if (element && otherElement) {
        addScrollEvent(element, otherElement);
      }
      return () => {
        removeScrollEvent(element);
        removeScrollEvent(otherElement);
      };
    };
    t1 = [element, otherElement];
    $[0] = element;
    $[1] = otherElement;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}